import { TYPE_SET_STEP, TYPE_SET_SUBSTEP, TYPE_ADD_TO_BOX, TYPE_REMOVE_FROM_BOX, TYPE_SET_ITEM_AMOUNT, TYPE_SWAP_BOX_ITEMS, TYPE_SET_SUMMARY_STEP, TYPE_SET_NEXT_TO_SUMMARY, TYPE_SET_ERROR, TYPE_SET_BOTTOM_TOOLBAR_EXPANDED, TYPE_SET_CURRENT_CATEGORY, TYPE_SET_CATEGORIES, TYPE_SET_GIFTS, TYPE_SET_ADDONS } from "./mutations";
import axios from 'axios';
import { saveAddress } from "../api/address";
import { getBabAddons, getBabTypes, getGifts, getProduct } from "../api/products";
import moment from "moment";
export const ACTION_GO_NEXT = "goNext";
export const ACTION_GO_BACK = "goBack";
export const ACTION_MODIFY_BOX = "modifyBox";
export const ACTION_ADD_TO_CART = "addToCart";
export const ACTION_ADD_ADDRESS = 'addAddress';
export const ACTION_GET_DATA = 'getData';

const actions = {
    [ACTION_GO_NEXT]({commit, state, dispatch}){
        //check delivery date
        if(state.step == 1 && state.substep == 1){
            if(!state.deliveryArea){
                commit(TYPE_SET_ERROR, 'Please select a location');
                document.querySelector('#location-picker').scrollIntoView();
                return;
            }
            if(!state.delivery.delivery_date){
                commit(TYPE_SET_ERROR, 'Please select a delivery date');
                document.querySelector('.hb-date-picker .input-wrapper').classList.add('error--text');
                document.querySelector('.hb-bab-wrapper').scrollIntoView();
                return;
            }
        }

        //check if there is at least one product
        if(state.step == 1 && state.substep == 3 && state.box.filter(item => item.boxContentType == 'boxContent').length < 3){
            commit(TYPE_SET_ERROR, 'Please select at least 3 products')
            return;
        }

        //check if card exceed length
        if(state.step == 3 && state.substep == 3 && state.cardMessage.length > 250){
            commit(TYPE_SET_ERROR, 'Message length should not exceed 250 characters.')
            return;
        }

        if(state.nextToSummary){
            commit(TYPE_SET_STEP, 5);
            commit(TYPE_SET_SUBSTEP, 3);
            commit(TYPE_SET_NEXT_TO_SUMMARY, false);
            return;
        }

        if(state.step == 1 && state.substep < 3){
            commit(TYPE_SET_SUBSTEP, state.substep + 1)
            return;
        }

        //default card
        // if(state.step === 3){
        //     dispatch(ACTION_MODIFY_BOX,{product: state.giftCards.products[0], amount: 1, boxContentType: 'card', variant: state.giftCards.products[0].variants[0]})
        // }

        commit(TYPE_SET_STEP, ++state.step);
    },
    [ACTION_GO_BACK]({commit, state}){
        
        if(state.nextToSummary){
            commit(TYPE_SET_STEP, 5);
            commit(TYPE_SET_SUBSTEP, 3);
            commit(TYPE_SET_NEXT_TO_SUMMARY, false);
            commit(TYPE_SET_BOTTOM_TOOLBAR_EXPANDED, false);
            return;
        }
        //replace step == 1 afterward (chk which multiple steps component is)!!!
        if(state.substep > 1 && state.step == 1){
            commit(TYPE_SET_SUBSTEP, --state.substep);
            commit(TYPE_SET_CURRENT_CATEGORY, null);
            return;
        }

        if(state.step == 1) return;
        
        commit(TYPE_SET_STEP, --state.step);

    },
    [ACTION_MODIFY_BOX]({commit, state, getters}, {product, amount, boxContentType, variant}){
        if(amount < 0) return;
        
        //TODO refactor
        //check if box exist
        const boxIndex = state.box.findIndex(boxItem => boxContentType == 'boxType' && boxItem.boxContentType == 'boxType');
        if(boxIndex >= 0){
            product.boxContentType = boxContentType;
            product.selectedVariant = variant.id;
            product.sku = variant.sku; 
            product.variantPrice = variant.price;
            product.name = variant.name;
            commit(TYPE_SWAP_BOX_ITEMS, {newItem: product, itemIndex: boxIndex});
            return;
        }

        //check if card exist
        const cardIndex = state.box.findIndex(boxItem => boxContentType == 'card' && boxItem.boxContentType == 'card' && amount > 0);
        if(cardIndex >= 0){
            product.boxContentType = boxContentType;
            product.selectedVariant = variant.id;
            product.sku = variant.sku; 
            product.variantPrice = variant.price;
            product.name = variant.name;
            commit(TYPE_SWAP_BOX_ITEMS, {newItem: product, itemIndex: cardIndex});
            return true;
        }

        //check if flower addon exist
        const flowerIndex = state.box.findIndex(boxItem => boxContentType == 'boxAddons' && boxItem.boxContentType == 'boxAddons' && product.tags.includes('flowers') && amount > 0);
        if(flowerIndex >= 0){
            product.boxContentType = boxContentType;
            product.selectedVariant = variant.id;
            product.sku = variant.sku; 
            product.variantPrice = variant.price;
            product.name = variant.name;
            commit(TYPE_SWAP_BOX_ITEMS, {newItem: product, itemIndex: flowerIndex});
            return true;
        }
        
        const itemIndex = state.box.findIndex(boxItem => 
            (product?.selectedVariant && 
            boxItem?.selectedVariant == product?.selectedVariant && 
            boxItem?.boxContentType == boxContentType) ||
            boxItem.id == product.id
        );

        //add if item not found
        if(itemIndex < 0){
            product.boxContentType = boxContentType;
            product.amount = amount;
            product.selectedVariant = variant.id;
            product.sku = variant.sku; 
            product.variantPrice = variant.price;
            product.name = variant.name;
            product.featured_image = variant.featured_image || product.featured_image;
            commit(TYPE_ADD_TO_BOX, product);
            return;
        }

        //if changed variant
        if(itemIndex >= 0 && variant && product.selectedVariant != variant.id){
            product.selectedVariant = variant.id;
            product.sku = variant.sku; 
            product.variantPrice = variant.price;
            product.name = variant.name;
            product.featured_image = variant.featured_image || product.featured_image;
            commit(TYPE_SWAP_BOX_ITEMS, {newItem: product, itemIndex});
        }

        if(amount === 0){
            commit(TYPE_REMOVE_FROM_BOX, itemIndex);

            if((product.boxContentType == 'boxContent' || boxContentType == 'boxContent') && state.box.length == 1){
                commit(TYPE_SET_STEP, 1);
                commit(TYPE_SET_SUBSTEP, 3);
                commit(TYPE_SET_ERROR, 'Please add a product into box')
            }

            return;
        }

        //set content type for product if not exist
        if(!state.box[itemIndex].boxContentType)
            product.boxContentType = boxContentType;
        //check box is maximum and adding
        if(getters.boxSize > 100 && state.box[itemIndex].amount < amount){
            commit(TYPE_SET_ERROR, 'The box is full.')
            return;
        }

        commit(TYPE_SET_ITEM_AMOUNT, {amount, itemIndex});
    },
    validateDate({state}){
        let timeslots = state.timeslots;
        const isCake = this.isCake;
        const date = moment(state.delivery.delivery_date);
        const timeSlotName = date.isBefore('2023-04-21')? 'ramadan':'general';
        const productType = isCake? 'cake':'general';
    
        timeslots = timeslots.filter(ts => 
            ts.delivery_plan === state.delivery.delivery_plan && 
            ts.product_type == productType && 
            // ts.time_slot_name == timeSlotName && 
            ts.delivery_area != 'nationwide'
        );
    
        const isBefore = moment().isBefore(
            moment(timeslots[state.delivery.delivery_time - 1].cutoff_time, "HHmm")
        );
        const isToday = moment(state.delivery.delivery_date).isSame(new Date(), "day")
        if(!isToday) return true;
        return isToday && isBefore;
    
    },
    validateAddons({getters}){
        return !getters.checkedAddons.some(addon => addon.isValid === false);
    },
    validateContent({state}){
        const boxContent = state.box.filter(content => content.boxContentType == 'boxContent');
        return boxContent.length >= 3;
        
    },
    async [ACTION_ADD_TO_CART]({state, getters, dispatch, commit}){
        if(!(await dispatch('validateAddons'))){
            commit(TYPE_SET_ERROR, 'Please update the unavailable products.');
            return;
        }
        if(!(await dispatch('validateDate'))){
            dispatch(ACTION_GO_BACK);
            commit(TYPE_SET_ERROR, 'Please update the delivery timeslot.');
            return;
        }

        if(!(await dispatch('validateContent'))){
            commit(TYPE_SET_ERROR, 'Please select at least 3 products.');
            commit(TYPE_SET_STEP, 1);
            commit(TYPE_SET_SUBSTEP, 2);
            return;
        }

        const _purchase_timestamp = Date.now();
        const _box_type = state.box.filter(content => content.boxContentType == 'boxType');
        const _box_content = state.box.filter(content => content.boxContentType == 'boxContent');
        const _product_addons = state.box.filter(content => content.boxContentType == 'boxAddons');
        const _card = state.box.filter(content => content.boxContentType == 'card');

        const boxTypeProperty = _box_type.map(item => {
            return {
                id: item.selectedVariant,
                product_type: item.type,
                sku: item.sku,
                quantity: 1,
                product_link: item.handle,
                price: item.price,
                subtotal: Number(item.variantPrice),
                name: item.name
            }
        })

        
        const boxContentProperty = _box_content.map(item => {
            return {
                id: item.selectedVariant,
                product_type: item.type,
                sku: item.sku,
                quantity: item.amount,
                product_link: item.handle,
                price: item.variantPrice,
                subtotal: Number(item.amount) * Number(item.variantPrice),
                name: item.name
            }
        })
        boxContentProperty.push(boxTypeProperty[0])

        const productAddOnproperty = _product_addons.map(item => {
            return {
                id: item.selectedVariant,
                product_type: item.type,
                sku: item.sku,
                quantity: item.amount,
                product_link: item.handle,
                price: item.variantPrice,
                subtotal: Number(item.amount) * Number(item.variantPrice),
                name: item.name
            }
        })

        const cardProperty = _card.map(item => {
            return {
                id: item.selectedVariant,
                product_type: item.type,
                sku: item.sku,
                quantity: 1,
                product_link: item.handle,
                price: item.variantPrice,
                subtotal: item.variantPrice,
                name: item.name
            }
        })

        const delivery = JSON.parse(JSON.stringify(state.delivery))
        delivery.delivery_area = state.deliveryArea;
        if(delivery.phone.substr(0,3) != '+60'){
            delivery.phone = '+60' + delivery.phone;
        }
        delivery.delivery_date = moment(delivery.delivery_date).utcOffset('+0800', true).startOf('day').toDate();

        const box = {
            quantity: state.productAmount,
            id: state.productDetails.variants[0].id,
            properties: {
                _box_type: boxTypeProperty[0],
                _box_content: boxContentProperty,
                _product_addons: productAddOnproperty,
                _product_card: cardProperty[0],
                _card_message: state.cardMessage,
                _card_signoff: state.signoff,
                _delivery: delivery,
                _delivery_fee: delivery.delivery_fee / state.productAmount,
                _delivery_plan: state.productDetails.locations,
                _purchase_timestamp,
                _product_type: state.productDetails.product_type,
                _product_tags: state.productDetails.tags,
                _type: 'product_main',
                _box_size: getters.boxSize
            }
        }

        //adding items inside box to cart
        const boxType = _box_type.map(item => {
            return {
                quantity: 1 * state.productAmount,
                id: item.selectedVariant,
                properties:{
                    _product_type: item.product_type,
                    _product_tags: item.tags,
                    _purchase_timestamp,
                    _hidden: true,
                    _type: 'bab_box_type',
                }
            }
        })

        //TODO: one item might have many variant
        const boxContent = _box_content.map(item => {
            return{
                quantity: item.amount * state.productAmount,
                id: item.selectedVariant,
                properties:{
                    _product_type: item.product_type,
                    _product_tags: item.tags,
                    _product_size: item.product_size,
                    _purchase_timestamp,
                    _hidden: true,
                    _type: 'bab_content',
                    _delivery: delivery,
                }
            }
        })

        const boxAddons = _product_addons.map(item => {
            return{
                quantity: item.amount * state.productAmount,
                id: item.selectedVariant,
                properties:{
                    _product_type: item.product_type,
                    _product_tags: item.tags,
                    _purchase_timestamp,
                    _hidden: true,
                    _type: 'product_addon',
                    _delivery: delivery,
                }
            }
        })

        const cards = _card.map(item => {
            return{
                quantity: item.amount * state.productAmount,
                id: item.selectedVariant,
                properties:{
                    _product_type: item.product_type,
                    _product_tags: item.tags,
                    _purchase_timestamp,
                    _hidden: true,
                    _type: 'product_card',
                    _delivery: delivery,
                }
            }
        })

        dispatch(ACTION_ADD_ADDRESS).catch(err => {
            console.log(err)
            return;
        });

        await axios.post('/cart/add.js', {
            items: [
                box,
                ...boxType,
                ...boxContent,
                ...boxAddons,
                ...cards
            ]
        })
        .then(()=>{
            window.location.href = '/cart';
        })
        .catch(err => {
            alert(err?.response?.data?.description || 'Oops looks like something went wrong, please try again later.')
        })
    },
    async [ACTION_ADD_ADDRESS]({state}){
        if(!state.addToFavourite || !state.customerId || !state.customerHash)
            return;

        const {
            location_type, 
            full_name, 
            house_number, 
            company_name, 
            country, 
            condominium_name, 
            building_name, 
            department, 
            level,
            street_address,
            city,
            province,
            zip,
            phone
        } = state.delivery;

        const address = {
            "location_type": location_type,
            "full_name": full_name,
            "street_address": street_address,
            "city": city,
            "province": province,
            "zip": zip,
            "phone": phone,
            country: 'my'
        }

        if(location_type == 'house'){
            address.house_number = house_number;
        }
        else if(location_type == 'office'){
            address.company_name = company_name;
            address.building_name = building_name;
            address.department = department;
            address.level = level
        }
        else if(location_type == 'condominium-apartment'){
            address.condominium_name = condominium_name;
            address.level = level
        }
        else if(location_type == 'hotel-restaurant'){
            address.company_name = company_name;
            address.level = level;
        }

        await saveAddress(address, {
            customer_id: state.customerId,
            hash: state.customerHash
        })
    },
    async [ACTION_GET_DATA]({commit},{date, location}){
        commit(TYPE_SET_CATEGORIES, null);
        commit(TYPE_SET_GIFTS, null);
        commit(TYPE_SET_ADDONS, null);

        const category = await getBabTypes({date: moment(date).format('YYYYMMDD'),delivery_region:location})
        commit(TYPE_SET_CATEGORIES, category);

        const gifts = await getGifts({date: moment(date).format('YYYYMMDD'),delivery_region:location})
        commit(TYPE_SET_GIFTS, gifts);
    }
}

export default actions;